import { YieldHeroBackdrop } from "../BrandBackdrop";
import { Skeleton } from "../ui/skeleton";
import { AssetCardSkeleton } from "./AssetCardSkeleton";

export const RentalSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background relative overflow-hidden"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading rental properties"
    >
      <main className="pb-12 relative z-10">
        {/* Hero */}
        <div className="vestn-nav-opening mb-8">
          <YieldHeroBackdrop />
          <div className="container mx-auto px-4 lg:px-8 relative z-10 mb-4">
            <Skeleton className="h-4 w-28" />
          </div>
          <div className="container mx-auto px-4 lg:px-8 relative z-10">
            <Skeleton className="h-8 w-48 rounded-full mb-4" />
            <Skeleton className="h-10 w-72 mb-2" />
            <Skeleton className="h-10 w-48 mb-4" />
            <Skeleton className="h-5 w-full max-w-2xl mb-2" />
            <Skeleton className="h-5 w-2/3 max-w-md mb-6" />
            <div className="flex flex-wrap gap-4">
              <Skeleton className="h-10 w-44 rounded-xl" />
              <Skeleton className="h-10 w-44 rounded-xl" />
              <Skeleton className="h-10 w-44 rounded-xl" />
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 lg:px-8">
          {/* Stats grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="p-4 sm:p-6 rounded-xl sm:rounded-2xl bg-card border border-white/[0.07] space-y-2">
                <Skeleton className="h-8 w-8 sm:h-10 sm:w-10 rounded-lg" />
                <Skeleton className="h-6 w-16" />
                <Skeleton className="h-3 w-24" />
              </div>
            ))}
          </div>

          {/* Toolbar */}
          <div className="flex flex-col sm:flex-row gap-3 mb-6 sm:mb-8">
            <Skeleton className="h-12 flex-1 rounded-xl" />
            <Skeleton className="h-12 w-[150px] rounded-xl" />
            <Skeleton className="h-12 w-[150px] rounded-xl" />
          </div>

          {/* Cards */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <AssetCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};
